@use "../../helpers/tableStyles/TableStyles.scss";

@use "variables" as *;

@mixin shadeOfGrey1 {
  background-color: rgba(200, 200, 200, 1);
}
@mixin shadeOfGrey2 {
  background-color: rgba(200, 200, 200, 0.95);
}
@mixin shadeOfGrey3 {
  background-color: rgba(200, 200, 200, 0.9);
}
@mixin shadeOfGrey4 {
  background-color: rgba(200, 200, 200, 0.8);
}
@mixin shadeOfGrey5 {
  background-color: rgba(200, 200, 200, 0.75);
}
@mixin shadeOfGrey6 {
  background-color: rgba(200, 200, 200, 0.65);
}
@mixin shadeOfGrey7 {
  background-color: rgba(200, 200, 200, 0.55);
}
@mixin shadeOfGrey8 {
  background-color: rgba(200, 200, 200, 0.5);
}
@mixin shadeOfGrey9 {
  background-color: rgba(200, 200, 200, 0.4);
}
@mixin shadeOfGrey10 {
  background-color: rgba(200, 200, 200, 0.3);
}

.label {
  height: 12px;
  width: 60px;
}

.value {
  height: 14px;
  margin-top: 12px;
}

.valueLong {
  width: 110px;
}

.valueShort {
  width: 30px;
}

.editButton {
  height: $input-height-mobile;
  width: $input-height-mobile;
  position: absolute;
  right: $spacing-4;
  @include shadeOfGrey1;
}

.grid {
  display: grid;

  grid-template-columns: repeat(1, auto);
  grid-template-rows: repeat(6, auto);
  grid-template-areas:
    "statusAndLineCode"
    "date"
    "route"
    "pax"
    "seats";

  @include on-bp(sm) {
    grid-template-columns: 42% 58%;
    grid-template-rows: repeat(3, auto);
    grid-template-areas:
      "statusAndLineCode ."
      "date route"
      "pax seats";
  }

  @include on-bp(lg) {
    grid-template-columns: 24% 36% 20% 20%;
    grid-template-rows: repeat(2, auto);
    grid-template-areas:
      "statusAndLineCode . . ."
      "date route pax seats";
  }
}

.statusAndLineCode {
  display: flex;
  column-gap: $spacing-2;

  grid-area: statusAndLineCode;
  margin-top: 3px;

  .statusAndLineCodeItem {
    height: 20px;
    @include shadeOfGrey1;

    &:first-child {
      width: 62px;
    }
    &:last-child {
      width: 80px;
    }
  }
}

.date {
  grid-area: date;
  margin-top: 18px;

  .label {
    @include shadeOfGrey2;
    @include on-bp(lg) {
      @include shadeOfGrey8;
    }
  }

  .value {
    @include shadeOfGrey3;
    @include on-bp(lg) {
      @include shadeOfGrey9;
    }
  }
}

.route {
  grid-area: route;
  margin-top: 20px;

  @include on-bp(sm) {
    margin-top: 19px;
  }

  .label {
    @include shadeOfGrey4;
    @include on-bp(sm) {
      @include shadeOfGrey2;
    }
    @include on-bp(lg) {
      @include shadeOfGrey8;
    }
  }

  .connection {
    width: 250px;
    margin-top: 6px;

    .skeleton {
      height: 14px;
      margin-top: 5px;
      @include shadeOfGrey5;
      @include on-bp(sm) {
        @include shadeOfGrey3;
      }
      @include on-bp(lg) {
        @include shadeOfGrey9;
      }
    }
  }
}

.pax {
  grid-area: pax;
  margin-top: 21px;

  .label {
    @include shadeOfGrey6;
    @include on-bp(sm) {
      @include shadeOfGrey8;
    }
  }
  .value {
    @include shadeOfGrey7;
    @include on-bp(sm) {
      @include shadeOfGrey9;
    }
  }
}

.seats {
  grid-area: seats;
  margin-top: 19px;

  .label {
    @include shadeOfGrey8;
  }
  .value {
    @include shadeOfGrey9;
  }
}

.checkInButton {
  height: $input-height-mobile;
  margin-top: 16px;

  @include shadeOfGrey10;

  @include on-bp(sm) {
    width: 215px;
  }
  @include on-bp(lg) {
    display: none;
  }
}
